export class BodyPayLoad
{
  public OrderId: string;
  public OrderNo: string;
  public TransactionId: string;
  public TransactionNo: string;
}
